enum ClientRowErrorVariant {
  EMPTY = 'EMPTY',
  BAD_FORMAT = 'BAD_FORMAT',
  ALREADY_EXIST = 'ALREADY_EXIST'
}

export default ClientRowErrorVariant;